export default __webpack_public_path__ + "static/media/menu.d87f472b.svg";